<script setup>
defineProps({
  label: { type: String, default: '' },
  message: { type: String, default: '' },
  state: {
    type: String,
    default: 'neutral',
    validator: value =>
      ['neutral', 'error', 'success', 'warning'].includes(value),
  },
});

const iconByState = {
  neutral: 'i-lucide-info',
  error: 'i-lucide-circle-alert',
  success: 'i-lucide-circle-check',
  warning: 'i-lucide-triangle-alert',
};

const colorByState = {
  neutral: 'text-lais-text-helper',
  error: 'text-lais-danger',
  success: 'text-lais-success',
  warning: 'text-lais-warning',
};
</script>

<template>
  <div class="grid gap-1">
    <label
      v-if="label"
      class="lais-field-feedback__label text-lais-label-sm font-semibold text-lais-text"
    >
      {{ label }}
    </label>
    <p
      v-if="message"
      class="lais-field-feedback__message inline-flex items-start text-lais-label-sm"
      :class="colorByState[state]"
    >
      <span
        class="lais-field-feedback__icon mt-0.5 size-3.5 shrink-0"
        :class="iconByState[state]"
        aria-hidden="true"
      />
      <span>{{ message }}</span>
    </p>
  </div>
</template>

<style scoped>
.lais-field-feedback__label {
  margin: var(--lais-component-form-label-margin);
}

.lais-field-feedback__message {
  margin: var(--lais-component-form-feedback-message-margin);
}

.lais-field-feedback__icon {
  margin: var(--lais-component-form-feedback-icon-margin);
}
</style>
